export const hashImage = (e, callback) => {
  Array.from(e.target.files).forEach((file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = callback;
  });
};
